import { forwardRef, memo } from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
// local imports
import { GetComponentProps } from '../helpers/types';
import BoxTypography from '../mixins/BoxTypography';
// SCSS imports
import {
  tagLabel, smallLabel, course, advisor, active, inactive,
  outlined, published, draft, started, archived
} from './TagLabel.module.scss';

export type TagLabelVariant =
  'course' | 'advisor' | 'active' | 'inactive' | 'outlined' | 'published' | 'draft' | 'started' | 'archived';

type TagLabelProps = {
  readonly variant: TagLabelVariant;
  readonly small?: boolean;
  readonly title?: string;
  readonly sx?: GetComponentProps<typeof BoxTypography>['sx'];
}

const TagLabel = forwardRef<HTMLElement, TagLabelProps>(({
  variant,
  small = false,
  title,
  sx
}, ref) => (
  <BoxTypography
      ref={ref}
      sx={sx}
      variant="caption"
      textAlign="center"
      className={clsx(tagLabel, {
        [course]: variant === 'course',
        [advisor]: variant === 'advisor',
        [active]: variant === 'active',
        [inactive]: variant === 'inactive',
        [outlined]: variant === 'outlined',
        [published]: variant === 'published',
        [draft]: variant === 'draft',
        [started]: variant === 'started',
        [archived]: variant === 'archived',
        [smallLabel]: small
      })}
  >
    <FormattedMessage id={title || `common.tag.${variant}`} defaultMessage={title}/>
  </BoxTypography>
));

TagLabel.displayName = 'TagLabel';

export default memo(TagLabel);
